// This hacky filter checks if the string is one character long
// (e.g. 'A', 'B', 'C') for a hacky way to determine if the
// string is a error code severity class (since we can't ask
// angular-translate directly, ugh).

angular.module('am4').filter('errorCodeFallback', function() {
    return function(string) {
        if (angular.isString(string) && string.length !== 1) {
            return null;
        }

        return string;
    };
});



// WEBPACK FOOTER //
// ./src/app/filters/errorCodeFallback.js